import type { CompanyUserRole, User, UserAccountingFirm } from "@/types/user";
import _ from "lodash";
import { CompanyRole } from "../miscellaneous/authorization";

export enum UserAccountingFirmRole {
  USER = "user",
  ADMIN = "admin",
}

export enum SystemRole {
  SUPER_ADMIN = "superadmin",
}

export const getUserAccountingFirmRole = (
  user: User,
): "admin" | "user" | null => {
  if (_.isEmpty(user?.accountingFirms)) return null;
  return user.accountingFirms.some((firm) => firm.role === "admin")
    ? "admin"
    : "user";
};

export const getHighestUserCompanyRole = (
  user: User & { companies: CompanyUserRole[] },
) => {
  if (_.isEmpty(user?.companies)) return null;
  return user.companies.some(
    (role) => role.role === CompanyRole.CLIENT_SELF_BOOKING,
  )
    ? CompanyRole.CLIENT_SELF_BOOKING
    : CompanyRole.CLIENT;
};

export const getUserTypeFromCompanyRole = (role: CompanyRole | string) => {
  return role == CompanyRole.EDITOR || role == CompanyRole.OWNER
    ? "accounting_firm"
    : "company";
};
